import { render, staticRenderFns } from "./VcidPane.vue?vue&type=template&id=7d8e4fa5"
import script from "./VcidPane.vue?vue&type=script&lang=js"
export * from "./VcidPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports